export default __webpack_public_path__ + "fed0a6df916f5fee7465d0b3dd65fc91.png";